export const handleAddressOptions = (form: any, address: object) => {
  Object.entries(address).forEach(([key, value]) => {
    form.setFieldsValue({ [key]: value });
  });
};
